import { Component, Inject, LOCALE_ID, NgModule, OnInit } from '@angular/core';
import { CUSTOMERENVIRONMENT } from '@app/common/app-tokens';
import { Environment } from '@environments/interface.environment';
import { GITVERSION } from '@environments/git-version';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit {

  logo = this.environment.production ? `/${this.localeId.substr(0, 2)}/assets/logo.svg?v=${GITVERSION.hash}` : `assets/logo.svg?v=${GITVERSION.hash}`;

  workPlaceName = this.environment.featureSettings.workplaceName;

  constructor(@Inject(CUSTOMERENVIRONMENT) private environment: Environment, @Inject(LOCALE_ID) public localeId: string) {
  }

  ngOnInit() {
  }

}
@NgModule({
  declarations: [LogoComponent],
  exports: [LogoComponent],
})
export class LogoModule { }
